import { defaultHttpClient as axios } from './_HttpClient';
/**
 * 通过 ShoppingApp / ShoppingAppCA 等站点的 /ajax/GAEvent.aspx 中转向 GA4
 * Measurement Protocol 直发事件。避免前端 dataLayer.push 后立即跳转导致
 * GTM 请求被取消的丢事件问题。
 */
export function sendGAEvent(name, params = {}) {
    return axios.post('/ajax/GAEvent.aspx/Send', {
        name,
        params: {
            ...params,
            page_location: window.location.href,
            page_title: document.title,
            page_referrer: document.referrer,
        },
    });
}
